// ======================================================================
// File Name       : messageThread
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getMessageList(data) {
  return commonCallApi({
    path: 'message/GetList',
    data: { ...data },
  });
}

export function getMessageThreadUserRelation(data) {
  return commonCallApi({
    path: 'messageUserRelation/GetList',
    data: { ...data },
  });
}

export function downloadMessageAttachment(data) {
  return commonCallApi({
    path: 'message/Download',
    data: { ...data },
  });
}

export function registerEditMessageThread(data) {
  return commonCallApi({
    path: 'message/Edit',
    data: { ...data },
    muiltipart: 1,
  });
}

export function registerEditUserRelation(data) {
  return commonCallApi({
    path: 'messageUserRelation/Edit',
    data: { ...data },
  });
}

export function getMessageStructure(data) {
  return commonCallApi({
    path: 'message/GetStructure',
    data: { ...data },
  });
}
